import styled from 'styled-components';

const LoginContent = styled.div`
    padding: 0 20px 30px 20px;
    width: 100%;
    text-align: center;
    ${({ theme }) => theme.media.down('md')`
        padding: 0;
    `};
`;

export default LoginContent;
